<div class="choose-template">
  <div class="header">
    <h1>Choose The Channel Template That You Love</h1>
  </div>
  <main>
    <side-menu
      [templateCategories]="templateCategories"
      (categoryClicked)="redirectToCategory($event)"
      [currentCategory]="currentCategory"
    ></side-menu>
    <templates-window
      [templates]="
        templates
          | filterByCategory: currentCategory
          | filterByTitle: templateTitleFilter
      "
      (onTemplateClicked)="templateChoosen($event)"
    ></templates-window>
  </main>
  <div [hidden]="!showPreloader">
    <div class="create-channel-overlay"></div>
    <enter-channel-name
      (channelNameCreated)="createNewTenantAndTrialUserFromTemplate($event)"
      [hidden]="channelName"
    ></enter-channel-name>
    <div class="preloader" [hidden]="!channelName">
      <img style="height: 78px" src=".//assets/logo-loader-white.svg" />
      <div class="msg">Processing...</div>
    </div>
  </div>
</div>
